const isDev = process.env.NODE_ENV !== "production";

const serialize = (args) =>
  args.map((arg) => {
    if (arg instanceof Error) {
      return { message: arg.message, name: arg.name, stack: arg.stack };
    }
    return arg;
  });

const error = (...args) => {
  if (isDev) {
    console.error("[logger:error]", ...serialize(args));
  } else {
    console.error(...serialize(args));
  }
};

const warn = (...args) => {
  if (isDev) {
    console.warn("[logger:warn]", ...serialize(args));
  } else {
    console.warn(...serialize(args));
  }
};

const info = (...args) => {
  if (isDev) {
    console.info("[logger:info]", ...serialize(args));
  } else {
    console.info(...serialize(args));
  }
};

const logger = { error, warn, info };

export { error, warn, info };
export default logger;